import { applyMiddleware, createStore } from 'redux';
import thunk, { ThunkMiddleware } from 'redux-thunk';
import rootReducers, { RootState } from '../reducers';
import { composeWithDevTools } from 'redux-devtools-extension';

const store = createStore(
  rootReducers,
  composeWithDevTools(applyMiddleware(thunk as ThunkMiddleware<RootState, any>))
);

export default store;
